import { render, staticRenderFns } from "./marketPromotionalMaterials.vue?vue&type=template&id=10cf9cf2&scoped=true&"
import script from "./marketPromotionalMaterials.vue?vue&type=script&lang=js&"
export * from "./marketPromotionalMaterials.vue?vue&type=script&lang=js&"
import style0 from "./marketPromotionalMaterials.vue?vue&type=style&index=0&id=10cf9cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cf9cf2",
  null
  
)

export default component.exports